import { render, staticRenderFns } from "./AudienceBySource.vue?vue&type=template&id=b0fd26d8&scoped=true&"
import script from "./AudienceBySource.vue?vue&type=script&lang=js&"
export * from "./AudienceBySource.vue?vue&type=script&lang=js&"
import style0 from "./AudienceBySource.vue?vue&type=style&index=0&id=b0fd26d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fd26d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCard,VCardText,VDataTable,VSnackbar})
